import React from 'react';
import Joyride from 'react-joyride';
import { useTheme } from '@mui/material';

export function JoyrideComponent({
  run,
  handleJoyrideCallback,
  stepIndex,
  steps,
}) {
  const theme = useTheme();

  return (
    <Joyride
      run={run}
      showProgress={false}
      showSkipButton={false}
      hideCloseButton={true}
      disableOverlay={false}
      disableScrolling={true}
      continuous={true}
      locale={{
        back: 'Précédent',
        close: 'Fermer',
        last: 'Fermer',
        next: 'Suivant',
        open: "Ouvrir l'aide",
        skip: 'Fermer',
      }}
      callback={handleJoyrideCallback}
      stepIndex={stepIndex}
      steps={steps}
      styles={{
        options: {
          arrowColor: '#FFFFFF',
          backgroundColor: '#FFFFFF',
          primaryColor: theme.palette.secondary.main,
          textColor: '#313131',
          width: 'max-content',
        },
        tooltip: {
          padding: '8px',
        },
        tooltipContent: {
          padding: '8px',
          lineHeight: '1rem',
          fontSize: '0.8rem',
        },
        buttonNext: {
          fontSize: '0.8rem',
        },
        buttonBack: {
          fontSize: '0.8rem',
        },
      }}
    />
  );
}
